export default "__VITE_ASSET__Cypz8xxR__"